// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DEPRECATED: Migrate to ez-spinner.js functionality */
/* DEPRECATED */
.spinnerOverlay {
  text-align: center;
}

/* DEPRECATED */
.overlayLabel {
  padding: 4px;
  margin-top: 10%;
  margin-left: 25%;
  margin-right: 25%;
  background-color: var(--ezAlphaBackgroundWhite);
  color: var(--ezClockerBlack);
  font-size: 52pt;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezClockerWhite);
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ezclocker-spinner.css"],"names":[],"mappings":"AAAA,uDAAA;AAEA,eAAA;AAAgB;EACZ,kBAAA;AACJ;;AAEA,eAAA;AAAgB;EACZ,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;AAEJ","sourcesContent":["/* DEPRECATED: Migrate to ez-spinner.js functionality */\r\n\r\n/* DEPRECATED */.spinnerOverlay {\r\n    text-align: center;\r\n}\r\n\r\n/* DEPRECATED */.overlayLabel {\r\n    padding: 4px;\r\n    margin-top: 10%;\r\n    margin-left: 25%;\r\n    margin-right: 25%;\r\n    background-color: var(--ezAlphaBackgroundWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 52pt;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: var(--ezClockerWhite);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
